module.exports = {"id":"198420","name":"Abdul Majeed Waris","rating":"74","photo":"./data/images/photos/1/198420.png","club":{"name":"FC Porto","logo":"./data/images/clubs/FCPorto.png"},"positions":["BU","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AbdulMajeedWaris0.json
// module id = 64
// module chunks = 0